__turbopack_context__.v({
  "icon": "KcOscG_icon",
  "row": "KcOscG_row",
});
